import { Alert, AlertIcon, Flex } from '@chakra-ui/react';
import { Button } from 'newui/components/Button';
import { FiAlertTriangle } from 'react-icons/fi';

export interface RevisionRequestBannerProps {
    onViewRequest: () => void;
}

const RevisionRequestBanner: React.FC<RevisionRequestBannerProps> = ({
    onViewRequest,
}) => {
    return (
        <Alert
            status="warning"
            className="rounded-lg"
            data-testid="revision-request-banner"
        >
            <AlertIcon as={FiAlertTriangle} />
            <Flex
                className="w-full items-center justify-between"
                gap={4}
            >
                <span className="text-sm font-medium">
                    Quote Revision Requested
                </span>
                <Button
                    size="sm"
                    padding={2}
                    btntype='secondary'
                    onClick={onViewRequest}
                    data-testid="revision-banner-view-request-btn"
                >
                    View Request
                </Button>
            </Flex>
        </Alert>
    );
};

export { RevisionRequestBanner };
